import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { Data } from './VirtualizedTable';
import { Grid, IconButton, Tooltip, Typography } from '@mui/material';
import { Formik } from 'formik';
import {
    AppFormikTextField,
    // AppFormikTextField,
    AppPrimaryButton,
} from 'shared/components/AppComponents';
import { formattingDate } from 'shared/helpers/FormatDate';
import { ManagePacketService } from 'services';
import { Toast, Utils } from 'shared/helpers';
import { CM9Scheme } from 'validators/ReviewedPacketScheme';
import {
    downloadCSV,
    // downloadCSV,
    downloadFile,
    downloadPDF,
} from 'shared/helpers/DirectDownload';
import JSZip from 'jszip';
import FileSaver from 'file-saver';
import { areWeTestingWithJest } from 'test/helpers/formik';
import CloseIcon from '@mui/icons-material/Close';
import {
    useInterval,
    useMountedState,
    usePageLeave,
    useTimeoutFn,
    useUpdateEffect,
} from 'react-use';
import InfoIcon from '@mui/icons-material/Info';
import CircularProgressWithLabel from './CircularProgressWithLabel';
import { useDispatch, useSelector } from 'react-redux';
import { BroadcastActions } from 'state/broadcast/Action';
import { SocketActions } from 'state/socket/Action';
import { useLeavePrompt } from 'shared/helpers/UseExitPrompt';
import isPointerInside from 'shared/helpers/isPointerInside';

const MoveModal: React.FC<Props> = React.forwardRef(
    (
        { packetData, callbackClosingModal, callbackOpenModal, onMoveCM9 },
        ref
    ): React.ReactElement => {
        const [isSubmitting, setSubmitting] = React.useState<boolean>(false);
        const [isGeneratingZip, setGenerattingZip] =
            React.useState<boolean>(false);
        const [isDownloadedZip, setDownloadedZip] =
            React.useState<boolean>(false);
        const [isDownloadingPreferred, setDownloadingPreferred] =
            React.useState<boolean>(false);
        const [isDownloadingAudit, setDownloadingAudit] =
            React.useState<boolean>(false);
        const [disabledDownload, setDisableDownload] =
            React.useState<boolean>(false);
        const [disabledAuditDownload, setDisableAuditDownload] =
            React.useState<boolean>(false);
        const [timeoutCM9, settimeoutCM9] = React.useState<number>(
            (packetData?.cm9Timer ?? 30) * 1000
        );
        const isMounted = useMountedState();
        const [count, setCount] = React.useState(0);
        const [isDownloading, setDownloading] = React.useState<boolean>(false);

        const [data, setData] = React.useState<Data | null>(packetData);
        const [open, setOpen] = React.useState(false);
        const [thicknessTimer, setThicknessTimer] = React.useState<number>(3.6);
        const handleOpen = React.useCallback((): void => {
            setOpen(true);
            if (typeof callbackOpenModal === 'function') callbackOpenModal();
        }, []);
        const innerModalRef = React.useRef<HTMLDivElement | null>(null);
        const packetId = React.useMemo(
            () =>
                data && data.actions && data.actions.uuid
                    ? data.actions.uuid
                    : null,
            [data]
        );

        const callbackForPromptAlert = React.useCallback(() => {
            ManagePacketService.patchOperatorAction({
                open: false,
                packetId: packetId ?? '',
            })
                .then(() => {
                    const { current: modalRef } = innerModalRef;
                    modalRef?.classList.add('patch');
                    // Utils.handleSuccessResponse(response);
                    // navigate('/not-expected-packet', {
                    //     replace: true,
                    //     state: {
                    //         ...defaultState,
                    //         isOpen: false,
                    //     },
                    // });
                    // window.history.state.isOpen = false;
                    //               window.history.replaceState({ ba: false }, '');
                })
                .catch(Utils.handleErrorResponse);
        }, [packetId]);

        const [, showLeavePrompt] = useLeavePrompt(
            false,
            callbackForPromptAlert
        );
        const [isLeavePage, setLeavePage] = React.useState<boolean>(false);
        usePageLeave(() => {
            setLeavePage(true);
        });
        const handlePatchingOperatorLockWithTimeout = React.useCallback(() => {
            ManagePacketService.patchOperatorAction({
                open: true,
                packetId: packetId ?? '',
            })
                .then(() => {
                    // const { current: modalRef } = innerModalRef;
                    // modalRef?.classList.add('patch');
                    // Utils.handleSuccessResponse(response);
                    // navigate('/not-expected-packet', {
                    //     replace: true,
                    //     state: {
                    //         ...defaultState,
                    //         isOpen: false,
                    //     },
                    // });
                    // window.history.state.isOpen = false;
                    //               window.history.replaceState({ ba: false }, '');
                })
                .catch(Utils.handleErrorResponse);
        }, [packetId]);
        const [, cancelOperatorLock, resetOperatorLock] = useTimeoutFn(
            handlePatchingOperatorLockWithTimeout,
            500
        );
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        const handleMouseEnter = React.useCallback(
            (event: any) => {
                const { current: modalRef } = innerModalRef;

                if (isPointerInside(modalRef, event)) {
                    if (modalRef?.classList.contains('patch')) {
                        modalRef.classList.remove('patch');
                        resetOperatorLock();
                    }
                    setLeavePage(false);
                }
            },
            [resetOperatorLock]
        );
        useUpdateEffect(() => {
            const { current: modalRef } = innerModalRef;
            if (modalRef) {
                if (isLeavePage) {
                    modalRef.addEventListener('mouseenter', handleMouseEnter);
                } else {
                    modalRef.removeEventListener(
                        'mouseenter',
                        handleMouseEnter
                    );
                }
            }
        }, [isLeavePage]);
        React.useLayoutEffect(() => {
            if (open) {
                settimeoutCM9((data?.cm9Timer ?? 30) * 1000);
                setCount(0);
                setThicknessTimer(3.6);
                setDownloadedZip(true);
                showLeavePrompt(true);
                cancelOperatorLock();
            }
            if (open === false) {
                showLeavePrompt(false);
                setDownloadedZip(false);
                cancelOperatorLock();
            }
        }, [open, data]);
        React.useEffect(() => {
            cancelOperatorLock();
            return () => {
                cancelOperatorLock();
            };
        }, []);
        const handleClose = React.useCallback((): void => {
            if (
                !isGeneratingZip &&
                !isDownloading &&
                !isDownloadingAudit &&
                !isDownloadingPreferred
            ) {
                setOpen(false);
                if (typeof callbackClosingModal === 'function')
                    callbackClosingModal(
                        data && data.actions && data.actions.uuid
                            ? data.actions.uuid
                            : null
                    );
            }
        }, [
            callbackClosingModal,
            data,
            isDownloading,
            isDownloadingAudit,
            isDownloadingPreferred,
            isGeneratingZip,
        ]);

        const handleCloseSamePacket = React.useCallback((): void => {
            if (
                !isGeneratingZip &&
                !isDownloading &&
                !isDownloadingAudit &&
                !isDownloadingPreferred
            ) {
                setOpen(false);
                if (typeof callbackClosingModal === 'function')
                    callbackClosingModal(null);
            }
        }, [
            callbackClosingModal,
            isDownloading,
            isDownloadingAudit,
            isDownloadingPreferred,
            isGeneratingZip,
        ]);
        const handleProcess = React.useCallback((): void => {
            setOpen(false);
            if (typeof callbackClosingModal === 'function')
                callbackClosingModal(
                    data && data.actions && data.actions.uuid
                        ? data.actions.uuid
                        : null
                );
        }, [callbackClosingModal, data]);

        const handleSubmitFormik = React.useCallback(
            (values: FormikMoveModalProps) => {
                setSubmitting(true);
                ManagePacketService.moveToCM9({
                    // stepId: review._id,
                    cm9Number: values.CM9code ?? '',

                    packetId: data?.actions.uuid ?? '',
                })
                    .then((response) => {
                        setSubmitting(false);
                        Utils.handleSuccessResponse(response);
                        if (typeof onMoveCM9 === 'function')
                            onMoveCM9(data?.actions.uuid ?? '');
                        handleProcess();
                    })
                    .catch((error) => {
                        setSubmitting(false);
                        Utils.handleErrorResponse(error);
                    });
            },
            [data?.actions.uuid, handleProcess, onMoveCM9]
        );

        /**
         * get all pending docs using SaS service
         *
         * @param pendingDocs - "string" array of url document to generate signed url.
         * @returns {Promise<{ [key: string]: JSZipObject }>} A promise that resolves when all files is signed within SaS service.
         */
        // const getPendingProcessedDocs = React.useCallback<
        //     (pendingDocs: string[]) => Promise<{
        //         data: { data: { url: string } };
        //     }>[]
        // >(
        //     (pendingDocs: string[]) =>
        //         Array.from(pendingDocs).map(
        //             (el) =>
        //                 new Promise(async (resolve, reject) => {
        //                     await ManagePacketService.getSasToken({
        //                         fileName: el,
        //                         report: false,
        //                     })
        //                         .then(resolve)
        //                         .catch(reject);
        //                 })
        //         ),
        //     []
        // );

        /**
         * get all pending PDF using fetch download
         *
         * @param pendingDocs - "string" array of url document to download.
         * @returns {Promise<Blob>} A promise that resolves when all zip files are downloaded.
         */
        const getPendingPDF = React.useCallback<
            (pendingDocs: string[]) => Promise<Blob>[]
        >(
            (pendingZips: string[]) =>
                Array.from(pendingZips).map(
                    (el) =>
                        new Promise(async (resolve, reject) => {
                            downloadPDF(el).then(resolve).catch(reject);
                        })
                ),
            []
        );

        /**
         * Downloads an array of files based on the provided URLs.
         *
         * @param arrayOfObjects - "file" property with the URL.
         * @returns {Promise<void>} A promise that resolves when all files are downloaded.
         */
        const downloadDocs = async (reportSaS: string): Promise<void> => {
            const fileName: any = `${reportSaS
                .split('/')
                .pop()
                ?.split('.pdf')
                .shift()}.pdf`;
            await downloadFile(reportSaS, fileName);
        };

        /**
         * Downloads an array of files based on the provided URLs.
         *
         * @param arrayOfObjects - "file" property with the URL.
         * @returns {Promise<void>} A promise that resolves when all files are downloaded.
         */
        const downloadZipSaS = async (
            placeholder: string,
            urlSaS: string
        ): Promise<void> => {
            const downloadUrl = urlSaS;

            await downloadFile(downloadUrl, placeholder);
        };
        React.useLayoutEffect(() => {
            if (isMounted() && isDownloadedZip === false) {
                setThicknessTimer(0);
            }
            if (isDownloadedZip) {
                setThicknessTimer(3.6);
            }
        }, [isDownloadedZip]);
        useInterval(
            () => {
                if (count === timeoutCM9 / 1000) {
                    setDownloadedZip(false);

                    // handleClose();
                } else {
                    setCount(count + 1);
                }

                // remove when the timeout is used
                if (count < 0) {
                    setDownloadedZip(false);
                    // handleClose();
                }
            },
            isDownloadedZip ? 1000 : null
        );

        /**
         * Downloads an zip based on the provided URLs.
         *
         * @param arrayOfObjects - "file" property with the URL.
         * @returns {Promise<void>} A promise that resolves when all files are downloaded.
         */
        // const downloadZips = async (
        //     filename: string,
        //     pendingDocs?: { processedFile: string; placeholder: string }[]
        // ): Promise<void> => {
        //     setGenerattingZip(true);

        //     try {
        //         if (typeof filename === 'string') {
        //             if (pendingDocs && pendingDocs.length > 0) {
        //                 const arrayPendingDocs = pendingDocs;
        //                 const promisePendingSaSFile = getPendingProcessedDocs(
        //                     Array.from(arrayPendingDocs).map(
        //                         (o) => o.processedFile
        //                     )
        //                 );
        //                 const promisePendingZip = await Promise.all<{
        //                     data: { data: { url: string } };
        //                 }>(promisePendingSaSFile).then((values) =>
        //                     getPendingPDF(
        //                         Array.from(values).map((o) => o.data.data.url)
        //                     )
        //                 );
        //                 const ArrayZipFiles = await Promise.all<Blob>(
        //                     promisePendingZip
        //                 );

        //                 // create new zip when there is processedFile
        //                 const zip = new JSZip();
        //                 for (
        //                     let index = 0;
        //                     index < arrayPendingDocs.length;
        //                     // eslint-disable-next-line no-plusplus
        //                     index++
        //                 ) {
        //                     const element = arrayPendingDocs[index];
        //                     zip.file(element.placeholder, ArrayZipFiles[index]);
        //                 }
        //                 zip.generateAsync({ type: 'blob' }).then((content) => {
        //                     // see FileSaver.js
        //                     FileSaver.saveAs(content, filename);
        //                 });
        //             }
        //         }
        //         // setDownloadedZip(true);
        //         setGenerattingZip(false);
        //         // handleClose();
        //     } catch (error) {
        //         Utils.handleErrorResponse(error);
        //         setGenerattingZip(false);
        //     }
        // };

        // const getReducementInProcessedDocument = React.useCallback(
        //     (prev: any[], current: any) => {
        //         const arrayDocument = prev;
        //         if (
        //             arrayDocument.some(
        //                 (i) => i.placeholder === current.placeholder
        //             ) === false
        //         ) {
        //             arrayDocument.push(current);
        //         }

        //         return arrayDocument;
        //     },
        //     []
        // );
        /**
         * get all pending CSV using fetch download
         *
         * @param pendingDocs - "string" array of url document to download.
         * @returns {Promise<Blob>} A promise that resolves when all zip files are downloaded.
         */
        const getPendingCSV = React.useCallback<
            (pendingDocs: string[]) => Promise<Blob>[]
        >(
            (pendingZips: string[]) =>
                Array.from(pendingZips).map(
                    (el) =>
                        new Promise(async (resolve, reject) => {
                            downloadCSV(el).then(resolve).catch(reject);
                        })
                ),
            []
        );

        /**
         * Downloads an Zips based on the audited file url.
         *
         * @param arrayOfPendingPDF - "file" url in array.
         * @param arrayOfPendingCSV - "file" url in array.
         * @param packetId - "packetId" in string
         * @returns {Promise<void>} A promise that resolves when all files are downloaded.
         */
        const downloadAuditZips = async (
            arrayOfPendingPDF: string,
            arrayOfPendingCSV: string,
            placeholder: string,
            placeholderPendingCSV: string | undefined,
            placeholderPendingPDF: string | undefined
        ): Promise<void> => {
            let promisePendingBlobs: Blob[] = [];
            const countFile =
                typeof arrayOfPendingPDF === 'string' &&
                typeof arrayOfPendingCSV === 'string'
                    ? 2
                    : 1;
            try {
                if (arrayOfPendingPDF) {
                    const promisePendingDocs = getPendingPDF([
                        arrayOfPendingPDF,
                    ]);
                    const pendingBlobFromDocs = await Promise.all<Blob>(
                        promisePendingDocs
                    ).catch(() => []);
                    promisePendingBlobs =
                        promisePendingBlobs.concat(pendingBlobFromDocs);
                }
                if (arrayOfPendingCSV) {
                    const promisePendingCSV = await getPendingCSV([
                        arrayOfPendingCSV,
                    ]);
                    const pendingBlobFromCSV = await Promise.all<Blob>(
                        promisePendingCSV
                    ).catch(() => []);
                    promisePendingBlobs =
                        promisePendingBlobs.concat(pendingBlobFromCSV);
                }

                if (
                    Array.isArray(promisePendingBlobs) &&
                    promisePendingBlobs.length === countFile
                ) {
                    // create new zip when there is processedFile
                    const zip = new JSZip();

                    promisePendingBlobs.forEach((blob, i) => {
                        if (blob.type === 'application/pdf') {
                            zip.file(
                                placeholderPendingPDF || `file-audit-${i}.pdf`,
                                blob
                            );
                        } else {
                            zip.file(
                                placeholderPendingCSV || `file-audit-${i}.csv`,
                                blob
                            );
                        }
                    });

                    zip.generateAsync({ type: 'blob' }).then((content) => {
                        // see FileSaver.js
                        FileSaver.saveAs(
                            content,
                            `Cross_Check_Audit_${placeholder}`
                        );
                    });
                } else {
                    throw Error(
                        'Unable to process download. Please contact Support for assistance..'
                    );
                }
            } catch (error: any) {
                Toast.showErrorMessage(error.message);
            }
        };
        const handleAuditFilename = React.useCallback(
            (url: URL, type: string) =>
                url.pathname
                    ?.split('/')
                    .find((segment) => segment.includes(type)),
            []
        );
        const handlePacketAuditFile = React.useCallback(
            async (packetId: string, placeholder: string) => {
                setDownloadingAudit(true);
                ManagePacketService.getPacketAuditfile({
                    packetId,
                })
                    .then((response: any) => {
                        const { csvAuditFile, pdfAuditFile } =
                            response.data.data;
                        const csvAuditFilename = handleAuditFilename(
                            new window.URL(csvAuditFile),
                            '.csv'
                        );
                        const pdfAuditFilename = handleAuditFilename(
                            new window.URL(pdfAuditFile),
                            '.pdf'
                        );
                        downloadAuditZips(
                            pdfAuditFile,
                            csvAuditFile,
                            placeholder,
                            csvAuditFilename,
                            pdfAuditFilename
                        ).then(() => {
                            // setDownloadedZip(true);
                            setDownloadingAudit(false);
                        });
                    })
                    .catch((response) => {
                        Utils.handleErrorResponse(response);
                        setDownloadingAudit(false);
                    });
            },
            []
        );
        /**
         * Downloads an Zips based on the preffered array.
         *
         * @param arrayOfPendingPDF - "file" url in array.
         * @param arrayOfPendingCSV - "file" url in array.
         * @param packetId - "packetId" in string
         * @returns {Promise<void>} A promise that resolves when all files are downloaded.
         */
        const downloadPreferredZips = async (
            arrayOfPendingPDF: any,
            processedAudit: any,
            packetId: string
        ): Promise<void> => {
            let promisePendingBlobs: Blob[] = [];
            setDownloadingPreferred(true);

            const filteredPendingPDF = arrayOfPendingPDF.filter(
                (e: any) => e.fileSasToken !== null
            );
            try {
                if (filteredPendingPDF) {
                    const arrayOfDownloadPDF = await Promise.all(
                        filteredPendingPDF
                            .map(
                                async (obj: any): Promise<Blob> =>
                                    new Promise(async (resolve, reject) => {
                                        if (obj.type === 'csv') {
                                            downloadCSV(obj.fileSasToken)
                                                .then(resolve)
                                                .catch(reject);
                                        } else {
                                            downloadPDF(obj.fileSasToken)
                                                .then(resolve)
                                                .catch(reject);
                                        }
                                    })
                            )
                            .concat(
                                processedAudit.map((e: any) => {
                                    if (e.type === 'csv') {
                                        const promisePendingCSV = getPendingCSV(
                                            [e.processedFile]
                                        );
                                        return promisePendingCSV.at(0);
                                    }
                                    const promisePendingDocs = getPendingPDF([
                                        e.processedFile,
                                    ]);
                                    return promisePendingDocs.at(0);
                                })
                            )
                    ).catch(() => []);

                    const pendingBlobFromDocs = await Promise.all<Blob>(
                        arrayOfDownloadPDF
                    );
                    promisePendingBlobs =
                        promisePendingBlobs.concat(pendingBlobFromDocs);
                }
                const filteredPendingPDFConcated =
                    filteredPendingPDF.concat(processedAudit);

                if (
                    promisePendingBlobs &&
                    Array.isArray(promisePendingBlobs) &&
                    promisePendingBlobs.length > 0
                ) {
                    // create new zip when there is processedFile
                    const zip = new JSZip();

                    promisePendingBlobs.forEach((blob, i) => {
                        if (typeof blob !== 'undefined') {
                            zip.file(
                                filteredPendingPDFConcated[i].placeholder,
                                blob
                            );
                        }
                    });

                    zip.generateAsync({ type: 'blob' }).then((content) => {
                        // see FileSaver.js
                        FileSaver.saveAs(
                            content,
                            `Preferred Cross check records For ${packetId}`
                        );
                    });
                } else {
                    throw Error(
                        'Unable to process download. Please contact Support for assistance..'
                    );
                }
                // setDownloadedZip(true);
                setDownloadingPreferred(false);
            } catch (error: any) {
                setDownloadingPreferred(false);
                Toast.showErrorMessage(error.message);
            }
        };
        const handleReportFilename = React.useCallback(
            (filename: string, type: string) =>
                filename?.split('/').find((segment) => segment.includes(type)),
            []
        );
        React.useImperativeHandle(
            ref,
            () => ({
                setClose: () => {
                    handleClose();
                },
                setOpen: () => {
                    handleOpen();
                },
                setData: (_data: Data) => {
                    setData(_data);
                    setDisableAuditDownload(
                        _data.enableAuditDownload === false
                    );
                    setDisableDownload(_data.enableDocumentDownload === false);
                },
            }),
            [
                handleOpen,
                handleClose,
                setData,
                setDisableAuditDownload,
                setDisableDownload,
            ]
        );

        const socketState = useSelector((state: any) => state.socketState);
        const socketEvent = React.useMemo(
            () => socketState.socketData.eventName,
            [socketState.socketData.eventName]
        );
        const profileState = useSelector((state: any) => state.profileState);
        const isTabActive = useSelector(
            (state: any) => state.carryState.visibilityState
        );

        const dispatch = useDispatch();
        const [isGoingBackBySocket, setGoingBackBySocket] =
            React.useState<boolean>(false);
        const [isGoingBackBySocketSamePacket, setGoingBackBySocketSamePacket] =
            React.useState<boolean>(false);

        useUpdateEffect(() => {
            if (socketEvent !== null && open) {
                if (socketEvent === 'operatorAction') {
                    if (
                        // eslint-disable-next-line no-underscore-dangle
                        profileState.userInfo._id ===
                            socketState.socketData.operatorId &&
                        isTabActive === false
                    ) {
                        dispatch(
                            BroadcastActions.SetBroadcastProgression(true)
                        );
                        setGoingBackBySocketSamePacket(
                            socketState.socketData.packetId === packetId
                        );
                        setGoingBackBySocket(
                            socketState.socketData.packetId !== packetId
                        );
                    }
                }
                dispatch(SocketActions.ResetSocketEvent({}));
            }
        }, [socketEvent]);

        React.useEffect(() => {
            if (isGoingBackBySocket && open) {
                handleClose();
                setGoingBackBySocket(false);
            }
        }, [isGoingBackBySocket]);

        React.useEffect(() => {
            if (isGoingBackBySocketSamePacket && open) {
                handleCloseSamePacket();
                setGoingBackBySocketSamePacket(false);
            }
        }, [isGoingBackBySocketSamePacket]);

        const getOperatorName = React.useCallback((operatorName: any) => {
            const lastName =
                typeof operatorName === 'object' && operatorName !== null
                    ? operatorName.last
                    : '';
            const firstName =
                typeof operatorName === 'object' && operatorName !== null
                    ? operatorName.first
                    : '';
            const nameOperator = String(firstName)
                .substring(0, 1)
                .toUpperCase();

            return typeof operatorName === 'object' && operatorName !== null
                ? `${lastName}, ${nameOperator}`
                : '-';
        }, []);

        return (
            <Box>
                <Modal
                    ref={innerModalRef}
                    open={(open && data !== null) || areWeTestingWithJest()}
                    disableEscapeKeyDown={
                        isGeneratingZip ||
                        isDownloading ||
                        isDownloadingAudit ||
                        isDownloadingPreferred
                    }
                    onClose={handleClose}
                    aria-labelledby="parent-modal-title"
                    aria-describedby="parent-modal-description"
                >
                    {data !== null ? (
                        <Box className="container-move-modal">
                            <Box className="justify-space-between align-center px-5 pt-5">
                                <Typography variant="h3" className="title">
                                    Move this cross check to storage
                                </Typography>
                                <IconButton
                                    edge="end"
                                    onClick={handleClose}
                                    title="close"
                                >
                                    <CloseIcon className="close-icon" />
                                </IconButton>
                            </Box>
                            {false && (
                                <>
                                    <IconButton
                                        onClick={handleClose}
                                        aria-label="Example"
                                        className="container-close"
                                        title="close"
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                    <Typography
                                        variant="h2"
                                        id="parent-modal-title"
                                    >
                                        Move this Cross check to storage
                                    </Typography>
                                </>
                            )}
                            <Box className="container-move-detail">
                                <Grid container className="container-detail">
                                    <Grid item xs={6} className="move-detail">
                                        <Typography className="packet-data-label">
                                            SLA
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6} className="move-detail">
                                        <Typography
                                            className="packet-data"
                                            data-testid="sla"
                                        >{`${
                                            data.slaDateDifference || 0
                                        } days left`}</Typography>
                                    </Grid>

                                    <Grid item xs={6} className="move-detail">
                                        <Typography className="packet-data-label">
                                            Checklist
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6} className="move-detail">
                                        <Typography
                                            className="packet-data"
                                            data-testid="client"
                                        >
                                            {data.clientName}
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={6} className="move-detail">
                                        <Typography className="packet-data-label">
                                            Reference Number
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6} className="move-detail">
                                        <Typography
                                            className="packet-data"
                                            data-testid="bin"
                                        >
                                            {data.bin}
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={6} className="move-detail">
                                        <Typography className="packet-data-label">
                                            Envelope Number
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6} className="move-detail">
                                        <Typography
                                            className="packet-data"
                                            data-testid="loan"
                                        >
                                            {data.loanNumber}
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={6} className="move-detail">
                                        <Typography className="packet-data-label">
                                            Uploaded
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6} className="move-detail">
                                        <Typography
                                            className="packet-data"
                                            data-testid="upload-date"
                                        >
                                            {formattingDate(data.uploadedDate)}
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={6} className="move-detail">
                                        <Typography className="packet-data-label">
                                            Uploaded Age
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6} className="move-detail">
                                        <Typography
                                            className="packet-data"
                                            data-testid="created-date"
                                        >{`${
                                            data.createdAtDifference || 0
                                        } days ago`}</Typography>
                                    </Grid>

                                    <Grid item xs={6} className="move-detail">
                                        <Typography className="packet-data-label">
                                            Cross Check Type
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6} className="move-detail">
                                        <Typography
                                            className="packet-data"
                                            data-testid="packet-type"
                                        >
                                            {data.packetType}
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={6} className="move-detail">
                                        <Typography className="packet-data-label">
                                            Member ID
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6} className="move-detail">
                                        <Typography
                                            className="packet-data"
                                            data-testid="operator"
                                        >
                                            {getOperatorName(data.operatorName)}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Grid
                                container
                                spacing={2}
                                className="container-move-button"
                            >
                                {disabledDownload && (
                                    <Grid item xs={2}>
                                        <Tooltip
                                            open
                                            placement="left-start"
                                            title="The document download is disabled because the cross check record reached purge date"
                                        >
                                            <IconButton>
                                                <InfoIcon fontSize="large" />
                                            </IconButton>
                                        </Tooltip>
                                    </Grid>
                                )}
                                <Grid
                                    item
                                    xs={disabledDownload ? 10 : 12}
                                    className="move-button"
                                >
                                    <AppPrimaryButton
                                        title="Download documents"
                                        className="btn-small download"
                                        isLoading={isGeneratingZip}
                                        loadingText={
                                            'PROCESSING'
                                            // isGeneratingZip
                                            //     ? 'PROCESSING'
                                            //     : `Timeout in ${
                                            //           timeoutCM9 / 1000 - count
                                            //       }`
                                        }
                                        fullWidth
                                        loadingSize={22}
                                        disabled={
                                            isGeneratingZip || disabledDownload
                                        }
                                        onClick={() => {
                                            if (data.documentZipSAS) {
                                                setGenerattingZip(true);
                                                downloadZipSaS(
                                                    data.placeholder,
                                                    data.documentZipSAS
                                                ).finally(() =>
                                                    setGenerattingZip(false)
                                                );
                                            } else {
                                                Toast.showErrorMessage(
                                                    'Unable to process download. Please contact Support for assistance..'
                                                );
                                            }
                                        }}
                                    />
                                </Grid>

                                <Grid
                                    item
                                    xs={disabledAuditDownload ? 5 : 6}
                                    className="move-button"
                                >
                                    <AppPrimaryButton
                                        title="Download Report"
                                        className="btn-small download"
                                        isLoading={isDownloading}
                                        loadingText={
                                            'PROCESSING'
                                            // isDownloading
                                            //     ? 'PROCESSING'
                                            //     : `Timeout in ${
                                            //           timeoutCM9 / 1000 - count
                                            //       }`
                                        }
                                        loadingSize={22}
                                        fullWidth
                                        disabled={
                                            isDownloading ||
                                            disabledAuditDownload
                                        }
                                        onClick={() => {
                                            if (
                                                typeof data.reportSAS ===
                                                'string'
                                            ) {
                                                setDownloading(true);
                                                downloadDocs(
                                                    data.reportSAS
                                                ).then(() =>
                                                    setDownloading(false)
                                                );
                                            } else {
                                                Toast.showErrorMessage(
                                                    'Unable to process download. Please contact Support for assistance..'
                                                );
                                            }
                                        }}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    xs={disabledAuditDownload ? 5 : 6}
                                    className="move-button"
                                >
                                    <AppPrimaryButton
                                        title="Download Audit"
                                        className="btn-small download"
                                        isLoading={isDownloadingAudit}
                                        loadingText={
                                            'PROCESSING'
                                            // isDownloadingAudit
                                            //     ? 'PROCESSING'
                                            //     : `Timeout in ${
                                            //           timeoutCM9 / 1000 - count
                                            //       }`
                                        }
                                        loadingSize={22}
                                        fullWidth
                                        disabled={
                                            isDownloadingAudit ||
                                            disabledAuditDownload
                                        }
                                        onClick={() =>
                                            handlePacketAuditFile(
                                                data.actions.uuid,
                                                data.placeholder
                                            )
                                        }
                                    />
                                </Grid>
                                {disabledAuditDownload && (
                                    <Grid item xs={2}>
                                        <Tooltip
                                            open
                                            placement="right"
                                            title="The document download is disabled because the cross check record reached purge date"
                                        >
                                            <IconButton>
                                                <InfoIcon fontSize="large" />
                                            </IconButton>
                                        </Tooltip>
                                    </Grid>
                                )}
                                <Grid item xs={12} className="move-button">
                                    <AppPrimaryButton
                                        testid="download-report"
                                        title="Download Preferred Documents"
                                        className="btn-small download zip"
                                        isLoading={isDownloadingPreferred}
                                        loadingSize={22}
                                        fullWidth
                                        disabled={
                                            isDownloadingPreferred ||
                                            disabledDownload
                                        }
                                        onClick={() => {
                                            setDownloadingPreferred(true);
                                            ManagePacketService.getPacketAuditfile(
                                                {
                                                    packetId: data.actions.uuid,
                                                }
                                            )
                                                .then((response: any) => {
                                                    const {
                                                        // csvAuditFile,
                                                        pdfAuditFile,
                                                    } = response.data.data;
                                                    // const csvAuditFilename =
                                                    //     handleAuditFilename(
                                                    //         new window.URL(
                                                    //             csvAuditFile
                                                    //         ),
                                                    //         '.csv'
                                                    //     );
                                                    const pdfAuditFilename =
                                                        handleAuditFilename(
                                                            new window.URL(
                                                                pdfAuditFile
                                                            ),
                                                            '.pdf'
                                                        );
                                                    const processedAudit = [];
                                                    if (pdfAuditFilename) {
                                                        processedAudit.push({
                                                            processedFile:
                                                                pdfAuditFile,
                                                            placeholder:
                                                                pdfAuditFilename,
                                                            type: 'pdf',
                                                            category: 'report',
                                                        });
                                                    }
                                                    // if (csvAuditFilename) {
                                                    //     processedAudit.push({
                                                    //         processedFile:
                                                    //             csvAuditFile,
                                                    //         placeholder:
                                                    //             csvAuditFilename,
                                                    //         type: 'csv',
                                                    //         category: 'report',
                                                    //     });
                                                    // }
                                                    downloadPreferredZips(
                                                        data.preferredDocuments.concat(
                                                            [
                                                                {
                                                                    fileSasToken:
                                                                        data.reportSAS,
                                                                    processedFile:
                                                                        data.reportFile,
                                                                    placeholder:
                                                                        handleReportFilename(
                                                                            data.reportFile,
                                                                            '.pdf'
                                                                        ) ?? '',
                                                                    type: 'pdf',
                                                                    category:
                                                                        'report',
                                                                },
                                                            ]
                                                        ),
                                                        processedAudit,
                                                        data.actions.uuid
                                                    );
                                                })
                                                .catch((response: any) => {
                                                    setDownloadingPreferred(
                                                        false
                                                    );
                                                    Utils.handleErrorResponse(
                                                        response
                                                    );
                                                });
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Box id="action-to-process-move-request">
                                <Formik
                                    validationSchema={CM9Scheme}
                                    initialValues={{
                                        CM9code: '',
                                    }}
                                    enableReinitialize
                                    onSubmit={handleSubmitFormik}
                                >
                                    {({ handleSubmit, isValid }) => (
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <AppFormikTextField
                                                    name="CM9code"
                                                    placeholder="Reference Number"
                                                    className="reference-input"
                                                    onEnter={handleSubmit}
                                                    inputProps={{
                                                        // eslint-disable-next-line react/no-unstable-nested-components
                                                        endAdornment: (
                                                            <CircularProgressWithLabel
                                                                variant="determinate"
                                                                thickness={
                                                                    thicknessTimer
                                                                }
                                                                value={
                                                                    (timeoutCM9 /
                                                                        1000 -
                                                                        count) *
                                                                    (100 /
                                                                        (timeoutCM9 /
                                                                            1000))
                                                                }
                                                                placeholder={
                                                                    count ===
                                                                    timeoutCM9 /
                                                                        1000
                                                                        ? ''
                                                                        : String(
                                                                              timeoutCM9 /
                                                                                  1000 -
                                                                                  count
                                                                          )
                                                                }
                                                                size={25}
                                                                disableShrink
                                                            />
                                                        ),
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <AppPrimaryButton
                                                    disabled={
                                                        (!isValid &&
                                                            isSubmitting) ||
                                                        count ===
                                                            timeoutCM9 / 1000
                                                    }
                                                    title="Confirm & Proceed"
                                                    className="btn-small download"
                                                    isLoading={isSubmitting}
                                                    loadingSize={22}
                                                    loadingText="PROCESSING"
                                                    onClick={handleSubmit}
                                                />
                                            </Grid>
                                        </Grid>
                                    )}
                                </Formik>
                            </Box>
                        </Box>
                    ) : (
                        <div />
                    )}
                </Modal>
            </Box>
        );
    }
);

export default MoveModal;
